import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".CardIcon-module_cardIcon__6kAtM {\n  max-height: 28px;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n  transition-property: opacity, filter;\n}\n\n.CardIcon-module_clickable__-e4QI {\n  cursor: pointer;\n}\n\n.CardIcon-module_subtle__JhVxY {\n  filter: grayscale(100%);\n  opacity: 0.7;\n}";
var styles = {"cardIcon":"CardIcon-module_cardIcon__6kAtM","clickable":"CardIcon-module_clickable__-e4QI","subtle":"CardIcon-module_subtle__JhVxY"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=CardIcon.module.scss.js.map
